import path from 'path'
import ElectronIPC from './ElectronIPC'

export function isAudioFile(filename: string) {
    const fileType = path.extname(filename).toLowerCase().substring(1)
    const audioExtensions = [
        'mp3',
        'wav',
        'aiff',
        'm4a',
        'flac',
        'wma',
        'aac',
        'alac',
        'voc',
        'vox',
        'dsd',
        'pcm',
        'caf',
    ]
    return audioExtensions.includes(fileType)
}

/**
 * Verify file (pointed to by "path") according to the parameters provided.
 *
 * @param path
 * @param params
 */
export async function verifyFile(path: string): Promise<boolean> {
    const stats = await ElectronIPC.getFileStats(path)
    console.log(`verifyFile: got stats=${JSON.stringify(stats)} for file at path="${path}".`)
    if (!stats) {
        return false
    }
    return true
}
